module.exports = __webpack_public_path__ + "img/trip_sendai14.011d527e.jpg";